import { Emitter } from "@ciaopeople/cp-shatsu/Queues";
import { tryToPromise } from "../../shared.js";
import { AuthProviderIdentifier } from "../AuthProviderIdentifier.js";
import { ActualDataTuple, LoginError, LoginErrorCodes, ThirdPartyCientAuthData } from "../data/LoginData.js";
import { debug } from "../LoginDbg.js";
import { GSILoader } from "./commons/GSILoader.js";
import { LoginProvider } from "./LoginProvider.js";



const INTERNAL_PROVIDER_ID = AuthProviderIdentifier.GOOGLE;
const DEFAULT_SCOPES: string[] = ["https://www.googleapis.com/auth/user.gender.read", "https://www.googleapis.com/auth/user.birthday.read"];



// const originalScopeRegex = /https?:\/\/.+(?:\/([^/]+))\/?$/;

// function formatScopes (scopes: string[]): string[] {
//     const formatted: string[] = [];
//     scopes.forEach(el => {
//         const matches = el.match(originalScopeRegex);
//         if(matches && matches[1]) {
//             formatted.push(matches[1]);
//         }
//     });

//     return formatted;
// }



class GSIGoogleLogin implements LoginProvider {


    private initPromise: Promise<any> = null;
    private useScopes: string[];
    private allScopes: string[];
    private emitter: Emitter<ThirdPartyCientAuthData>;
    
    constructor(
                private readonly gsiLoader: GSILoader,
                scopes: string[]
    ) {

        this.emitter = new Emitter();
        this.useScopes = scopes?scopes:DEFAULT_SCOPES;
        this.allScopes = this.useScopes.concat(["profile", "email"]);
    }
    
    preloadAction(): Promise<void> {
        return Promise.resolve();
    }

    eventuallyHandleRevoke(hint: string, isDeleteRequest: boolean): Promise<boolean> {
        if(isDeleteRequest) {
            debug.write("GOO - Going for logout");
            return this.sdkInit().then(gaccounts => {
                
                //what can i do here
                console.log("What can i do here ....", gaccounts);
                return true;
            }).catch(e => {
                return false;
            });
        } 
        else {
            debug.write("GOO - Nothing to delete on request");
            return Promise.resolve(true);
        }
    }


    getSessionDataForAutologin(): Promise<ThirdPartyCientAuthData> {      
        return Promise.reject(new LoginError(LoginErrorCodes.NO_SESSION_FOUND, "Not Unsupported"));
    }
    promptLogin(): Promise<ThirdPartyCientAuthData> {
        return this.sdkInit().then(gaccounts => {
            
            console.log("Gaccounts.obj: ",gaccounts);
            const client = gaccounts.oauth2.initCodeClient({
                client_id: this.gsiLoader.client_id,
                callback: (tokenResponse) => {
                    console.log("token response from google:",tokenResponse);
                    tryToPromise(() => { 
                        return new ThirdPartyCientAuthData(null,
                            new ActualDataTuple(this.providerId,
                                null, 
                                null,
                                null,
                                tokenResponse.code
                            ));
                    }).then((tpd) => {
                        this.emitter.emit(tpd);
                    });
                },
                scope: this.allScopes.join(" "),
                ux_mode: "popup"
            });

            console.log("Gotback client",client);
            client.requestCode();
            const prom = this.emitter.next();
            return prom;
        });
            
    }
    oneTapLogin(): Promise<ThirdPartyCientAuthData> {
        return Promise.reject(new LoginError(LoginErrorCodes.NO_SESSION_FOUND, "One Tap is supported in a specific provider"));
    }
    sdkInit(): Promise<any> {
        if(this.initPromise == null) {
            this.initPromise = this.gsiLoader.gsiInit();
        }
        return this.initPromise;
    }
   
    niceName: string = "Google";
    supportsAutoLogin: boolean = false;
    useOwnLoginPrompt: boolean = true;
    providerId: AuthProviderIdentifier = INTERNAL_PROVIDER_ID;
    supportsOneTap: boolean = false;

}


export { GSIGoogleLogin };
